// extracted by mini-css-extract-plugin
module.exports = {"board":"dashboard_board__2PFaA","hr":"dashboard_hr__33_E7"};